import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import type { SxProps, Theme } from "@mui/material";
import {
	Card,
	CardContent,
	CardHeader,
	Divider,
	LinearProgress,
} from "@mui/material";
import { useAtom } from "jotai";
import type { FC, ReactNode } from "react";

type BaseCardProps = {
	title?: string | ReactNode;
	children: JSX.Element | JSX.Element[];
	sx?: SxProps<Theme>;
	sxCardContent?: SxProps<Theme>;
	action?: React.ReactNode;
	isLoading?: boolean;
};

export const BaseCard: FC<BaseCardProps> = ({
	title,
	children,
	sx,
	sxCardContent,
	action,
	isLoading,
}) => {
	const [themeConfiguration] = useAtom(themeAtom);

	return (
		<Card
			sx={{ padding: 0, ...sx }}
			elevation={themeConfiguration.isCardShadow ? 9 : 0}
			variant={!themeConfiguration.isCardShadow ? "outlined" : undefined}
		>
			{(title || action) && (
				<>
					<CardHeader
						title={title}
						sx={{ textAlign: "left" }}
						action={action}
					/>
					<Divider />
				</>
			)}
			{isLoading && (
				<LinearProgress color="secondary" sx={{ height: "2px" }} value={50} />
			)}

			<CardContent sx={{ ...sxCardContent }}>{children}</CardContent>
		</Card>
	);
};
